// Vendor Libraries
import { EventEmitter, SimpleChanges } from '@angular/core';
import cloneDeep from 'lodash.clonedeep';
// Constants
import { RELATIVE_ATTRIBUTION_PERIODICITY_OPTIONS } from 'SecuritiesApp/ts/constants/attribution.constants';
// Interfaces
import { PerformancePeriodicity } from 'SecuritiesApp/ts/interfaces/attribution.interface';
// Utils
import { isPeriodicityDisabled } from 'SecuritiesApp/ts/features/attribution-relative/utils';
import * as i0 from "@angular/core";
import * as i1 from "@angular/common";
import * as i2 from "../../../../../../../../../ycharts/static/ts/features/directives/disabled/disabled.directive";
const _c0 = a0 => ({ "text-gray-60": a0 });
function AttributionRelativeZoomControlsComponent_li_1_Template(rf, ctx) { if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "li")(1, "a", 2);
    i0.ɵɵlistener("click", function AttributionRelativeZoomControlsComponent_li_1_Template_a_click_1_listener() { const periodicityOption_r2 = i0.ɵɵrestoreView(_r1).$implicit; const ctx_r2 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r2.updatePeriodicity(periodicityOption_r2.value)); });
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const periodicityOption_r2 = ctx.$implicit;
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵclassMapInterpolate1("chart-control-item ", periodicityOption_r2.value === ctx_r2.performancePeriodicity ? "current" : "", "");
    i0.ɵɵadvance();
    i0.ɵɵproperty("disabled", periodicityOption_r2.disabled)("ngClass", i0.ɵɵpureFunction1(6, _c0, periodicityOption_r2.disabled));
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", periodicityOption_r2.label, " ");
} }
export class AttributionRelativeZoomControlsComponent {
    constructor() {
        this.asOfDateOption = '';
        this.periodicityChangeHandler = new EventEmitter();
        this.periodicityOptions = cloneDeep(RELATIVE_ATTRIBUTION_PERIODICITY_OPTIONS);
    }
    ngOnChanges(changes) {
        if (changes.asOfDateOption?.currentValue) {
            this.periodicityOptions.forEach((periodicity) => {
                // eslint-disable-next-line no-param-reassign
                periodicity.disabled = isPeriodicityDisabled(periodicity.value, changes.asOfDateOption.currentValue);
            });
        }
    }
    updatePeriodicity(periodicity) {
        if (!isPeriodicityDisabled(periodicity, this.asOfDateOption)) {
            this.periodicityChangeHandler.emit(periodicity);
        }
    }
}
AttributionRelativeZoomControlsComponent.ɵfac = function AttributionRelativeZoomControlsComponent_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || AttributionRelativeZoomControlsComponent)(); };
AttributionRelativeZoomControlsComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: AttributionRelativeZoomControlsComponent, selectors: [["ycn-attribution-relative-zoom-controls"]], inputs: { performancePeriodicity: "performancePeriodicity", asOfDateOption: "asOfDateOption" }, outputs: { periodicityChangeHandler: "periodicityChangeHandler" }, standalone: false, features: [i0.ɵɵNgOnChangesFeature], decls: 2, vars: 1, consts: [[1, "chart-control", "chart-control-compact", "border-0"], [3, "class", 4, "ngFor", "ngForOf"], ["href", "javascript:void(0)", "ycnDisabled", "", 1, "chart-control-link", 3, "click", "disabled", "ngClass"]], template: function AttributionRelativeZoomControlsComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "ul", 0);
        i0.ɵɵtemplate(1, AttributionRelativeZoomControlsComponent_li_1_Template, 3, 8, "li", 1);
        i0.ɵɵelementEnd();
    } if (rf & 2) {
        i0.ɵɵadvance();
        i0.ɵɵproperty("ngForOf", ctx.periodicityOptions);
    } }, dependencies: [i1.NgClass, i1.NgForOf, i2.DisabledDirective], encapsulation: 2 });
